var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "camera-chart2" },
    [
      _c(
        "a-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v("今日抓拍学生量"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title-1",
                        staticStyle: { "font-size": "22px" },
                      },
                      [_vm._v(_vm._s(_vm.chartData.todayStudentCount))]
                    ),
                  ]),
                  _c("mini-area", {
                    attrs: {
                      dataSource: _vm.chartData.studentList,
                      chartConfig: {
                        height: 200,
                        padding: [40, 40, 40, 40],
                      },
                      showXAxis: true,
                      y: "抓拍学生量",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-col",
            { attrs: { sm: 24, md: 12, lg: 12, xl: 12 } },
            [
              _c(
                "a-card",
                { staticClass: "card-item", attrs: { loading: _vm.loading } },
                [
                  _c("div", { staticClass: "flex-align-center" }, [
                    _c("span", { staticStyle: { "margin-right": "5px" } }, [
                      _vm._v("今日相机采集量"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass: "title-1",
                        staticStyle: { "font-size": "22px" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.chartData.todayStudentFaceCount) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _c("mini-area", {
                    attrs: {
                      "data-source": _vm.chartData.studentFaceList,
                      chartConfig: {
                        height: 200,
                        padding: [40, 40, 40, 40],
                      },
                      showXAxis: true,
                      y: "相机采集量",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-card" },
        [
          _c(
            "div",
            {
              staticClass: "title-1",
              staticStyle: { "margin-bottom": "15px" },
            },
            [_vm._v("设备运行情况")]
          ),
          _c("a-table", {
            ref: "table",
            staticClass: "j-table-force-nowrap",
            attrs: {
              size: "middle",
              bordered: "",
              columns: _vm.columns,
              dataSource: _vm.dataSource,
              pagination: _vm.ipagination,
              loading: _vm.loading,
            },
            on: { change: _vm.handleTableChange },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }